export const apiName: string = 'marcas';
export const marcasRoute: string = 'marcas';
export const marcasStorage: string = 'marcas';
export const marcasModuleName: any = {plural: 'Marcas', single: 'Marca'};

export const marcasQuery: any = {
  "where":{
    "ativo":true,
    "marca":{"regexp":"/REPLACEHERE/i"}
  },
  "order":"marca"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/shared/data.service.ts
 **/